// Parses CSV text into JSON by taking the first line's headers and using them as the keys for the objects that are added into the result array.
export const csvJSON = (
  csvText: string | undefined,
): Array<Record<string, string>> => {
  if (!csvText) return [];

  // Normalize newlines and remove BOM if present
  const text: string = csvText
    .replace(/^\uFEFF/, '')
    .replace(/\r\n/g, '\n')
    .replace(/\r/g, '\n');

  // Split and drop completely empty trailing lines
  const lines = text.split('\n').filter((l) => l.trim().length > 0);
  if (lines.length === 0) return [];

  const formatJSONKeys = (s: string) =>
    s.trim().toLowerCase().replace(/\s+/g, '_');

  // Safer parser that avoids Regex infinite loops
  const parseLine = (t: string): string[] => {
    const result: string[] = [];
    let curVal = '';
    let inQuote = false;

    for (let i = 0; i < t.length; i++) {
      const char = t[i];

      if (inQuote) {
        if (char === '"') {
          // Check for escaped quote ("")
          if (i + 1 < t.length && t[i + 1] === '"') {
            curVal += '"';
            i++; // Skip the next quote
          } else {
            inQuote = false; // Closing quote found
          }
        } else {
          curVal += char;
        }
      } else {
        if (char === '"') {
          inQuote = true; // Opening quote found
        } else if (char === ',') {
          result.push(curVal.trim()); // Comma found, push field
          curVal = '';
        } else {
          curVal += char;
        }
      }
    }
    // Push the last field
    result.push(curVal.trim());
    return result;
  };

  const rawHeaders = parseLine(lines[0]);
  const headers = rawHeaders.map(formatJSONKeys);

  const result: Array<Record<string, string>> = [];

  for (let i = 1; i < lines.length; i++) {
    const fields = parseLine(lines[i]);

    // Skip lines that don't match header length roughly or are empty
    if (fields.length === 1 && fields[0] === '') continue;

    const obj: Record<string, string> = {};
    // Map fields to headers; handle cases where row might be shorter than headers
    for (let j = 0; j < headers.length; j++) {
      obj[headers[j]] = fields[j] ?? '';
    }
    result.push(obj);
  }

  return result;
};
